import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";

export default function StudentAuthForm() {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [loginState, setLoginState] = useState("EMAIL_ENTRY"); // EMAIL_ENTRY or OTP_ENTRY
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const response = await Passwordless.createCode({ email });
            if (response.status === "OK") {
                setLoginState("OTP_ENTRY");
            } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
                setError("Unauthorized: Please contact your instructor to be added to a course.");
            } else {
                throw new Error("Failed to send login code. Please check the email and try again.");
            }
        } catch (err) {
            setError(err.message);
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const response = await Passwordless.consumeCode({ userInputCode: otp });
            if (response.status === "OK") {
                navigate("/");
            } else if (response.status === "INCORRECT_USER_INPUT_CODE_ERROR" || response.status === "EXPIRED_USER_INPUT_CODE_ERROR") {
                throw new Error("Invalid or expired OTP. Please try again.");
            } else {
                throw new Error("An unknown error occurred. Please try again.");
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            {loginState === "EMAIL_ENTRY" ? (
                <Box component="form" onSubmit={handleEmailSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    {error && <Alert severity="error" sx={{ width: '100%', mt: 2, mb: 2, borderRadius: '12px' }}>{error}</Alert>}
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ 
                            mt: 4, 
                            mb: 2,
                            py: 1.5,
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            boxShadow: 2,
                            '&:hover': {
                                boxShadow: 4
                            }
                        }}
                    >
                        Send Login Code
                    </Button>
                </Box>
            ) : (
                <Box component="form" onSubmit={handleOtpSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    {error && <Alert severity="error" sx={{ width: '100%', mt: 2, mb: 2, borderRadius: '12px' }}>{error}</Alert>}
                    <Typography variant="body2" sx={{ mb: 2, textAlign: 'center', color: 'text.secondary' }}>
                        A login code has been sent to <strong>{email}</strong>. Please enter it below.
                    </Typography>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="otp"
                        label="Login Code"
                        name="otp"
                        autoFocus
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ 
                            mt: 4, 
                            mb: 2,
                            py: 1.5,
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            boxShadow: 2,
                            '&:hover': {
                                boxShadow: 4
                            }
                        }}
                    >
                        Sign In
                    </Button>
                </Box>
            )}
        </Box>
    );
}
